// extracted by mini-css-extract-plugin
export default {"display_left":"style_display_left__qhL0q","display_right":"style_display_right__fXwxO","table_wrap":"style_table_wrap__6S+Wb","Job_Experience":"style_Job_Experience__qn-Wt"};